module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/bg_white_note-ebdd0e4f5f2f0d2978505cb529f50241.jpg";